










































import {Vue, Component} from 'vue-property-decorator';
import AppLink from '@/components/AppLink.vue';

@Component({
    name: 'MobileResume',
    components: {AppLink},
})
export default class MobileResume extends Vue {
    public experiences: any = {
        work: [
            {
                title: `Front-end Development Intern`,
                linkContent: `Degordian`,
                linkHref: `https://www.degordian.com`,
                date: `03/17 - 01/18`,
            },
            {
                title: `Front-end Developer`,
                linkContent: `Degordian`,
                linkHref: `https://www.degordian.com`,
                date: `01/18 - 12/18`,
            },
            {
                title: `Front-end Developer`,
                linkContent: `Bornfight`,
                linkHref: `https://www.bornfight.com`,
                date: `12/18 - 02/20`,
            },
        ],
        education: [
            {
                title: `Multimedia Computer Engineering`,
                linkContent: `Algebra`,
                linkHref: `https://www.algebra.hr/visoko-uciliste`,
                date: `09/13 - 04/17`,
            },
        ],
    };
}
